import { combineReducers } from 'redux';
import offersReducer from './offers/offers.slice';
import loyaltyOffersReducer from './loyalty-offers/loyalty-offers.slice';
import messagesReducer from './messages/messages.slice';
import orderAvailabilityReducer from './orderavailability/orderavailability.slice';

export default combineReducers({
  offers: offersReducer,
  loyaltyOffers: loyaltyOffersReducer,
  messages: messagesReducer,
  orderavailability: orderAvailabilityReducer,
});
